import React, { useEffect, useState } from "react";
import {
  AESEncryption,
  ApiResDecrypt,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import Loader from "../../Common/Loader";
import { numDifferentiation } from "../../../CommonMethhods/CovertRupees";
import { DASHBOARD_CLIENT_DETAIL_EQUITY } from "../../../Configuration/API_URL";
import { Constants } from "../../../CommonMethhods/Constants";
import { toast } from "react-toastify";
import SmallLoader from "../../Common/smallLoader";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function MarginDetails() {
  const storeToken = localStorage.getItem("ssoToken");
  const [marginDetails, setMarginDetails] = useState([]);
  const [loader, setLoader] = useState(false);
  const [commonError, setCommonError] = useState(false);
  const [totalMargin, setTotalMargin] = useState();
  const [smallLoaderPdf, setPdfLoader] = useState(false);
  const [smallLoaderExcel, setExcelLoader] = useState(false);

  const getMarginDetails = async (viewType = "grid") => {
    let clientCode = "";
    if (localStorage.getItem("clientCode")) {
      clientCode = localStorage.getItem("clientCode");
    }
    if (viewType === "grid") {
      setLoader(true);
    }

    if (viewType === "pdf") {
      setPdfLoader(true);
    }
    if (viewType === "excel") {
      setExcelLoader(true);
    }
    let payloadValue = { clientCode: clientCode, fileType: viewType };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        DASHBOARD_CLIENT_DETAIL_EQUITY.MarginDetail_URL,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        if (viewType === "grid") {
          setMarginDetails(res?.data?.marginDetail);
          setTotalMargin(res?.data?.TotalMargin);
          setCommonError(false);
        }
        if (viewType === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        }
        if (viewType === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        if (viewType !== "grid") {
          toast.error(res?.message);
        } else {
          setMarginDetails([]);
          setCommonError(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      setCommonError(error?.message);
    } finally {
      setLoader(false);
      setExcelLoader(false);
      setPdfLoader(false);
    }
  };
  useEffect(() => {
    getMarginDetails("grid");
  }, []);
  const handleOnClick = (e) => {
    if (e.target.value) {
      getMarginDetails(e.target.value);
    }
  };

  return (
    <>
      <div className="col-12 col-md-7 col-lg-8 mtf-detail-card">
        <div className="card-box margin-details">
          <div className="card-title">
            <h2 className="small-title">{Constants.Margin_details}</h2>
            <div className="left-title-margin">
              <div className="btn-wrapper-summary">
                <button
                  value="excel"
                  onClick={handleOnClick}
                  className="summary-btn excel-btn"
                >
                  {smallLoaderExcel ? (
                    <div>
                      <SmallLoader />
                    </div>
                  ) : (
                    <>
                      <span className="icon-excelsvg"></span>
                      Excel
                    </>
                  )}
                </button>
                <button
                  className="summary-btn pdf-btn"
                  value="pdf"
                  onClick={handleOnClick}
                >
                  {smallLoaderPdf ? (
                    <div>
                      <SmallLoader />
                    </div>
                  ) : (
                    <>
                      <span className="icon-pdfsvg"></span>
                      PDF
                    </>
                  )}
                </button>
              </div>
              <p className="margin-details__price">
                <i>₹ </i>
                {totalMargin ? numDifferentiation(totalMargin) : 0}
              </p>
            </div>
          </div>
          {loader ? (
            <div className="loader-alignment">
              <Loader />
            </div>
          ) : (
            <div className="scroll-table margin-details-table">
              {marginDetails && marginDetails?.length > 0 ? (
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">{Constants.Scrip_Name}</th>
                      <th scope="col">{Constants.Last_Traded_Price}</th>
                      <th scope="col">{Constants.Haircut_Rate}</th>
                      <th scope="col">{Constants.Margin_Provided}</th>
                    </tr>
                  </thead>

                  <tbody>
                    {marginDetails?.map((info, key) => {
                      return (
                        <tr key={key}>
                          <td>{info?.scriptname || "-"}</td>
                          <td>
                            {info?.lasttradedprice
                              ? numDifferentiation(info?.lasttradedprice)
                              : 0}
                          </td>

                          <td>
                            {info.haircutRate
                              ? numDifferentiation(info?.haircutRate)
                              : 0}
                          </td>
                          <td>
                            {info.marginprovided
                              ? numDifferentiation(info?.marginprovided)
                              : 0}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              ) : (
                commonError && (
                  <h4 className="no-data">{noDataFound(commonError)}</h4>
                )
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default MarginDetails;
